module.exports = __webpack_public_path__ + "img/kws.ffaf6f8c.svg";